import { Box, Grid, Tbody, Text, Tfoot, Thead } from '@chakra-ui/react'
import type { InsuranceParamsGridItem } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import { useContext, useMemo } from 'react'

import { contractsTravelContext } from '@/pages/travel/contracts'

import { contractsPropertyContext } from '@/pages/property/contracts'
import { Pagination, Table, TableData, TableHeader, TableRow } from '../../components/Grid'
import { Loading } from '../../components/Loading'
import { useApp } from '../../hooks/useApp'
import { contractsCarsContext } from '../../pages/vehicle/contracts'
import { ContractRow } from './ContractRow'

export const getContractsContext = (product: Product) => {
  switch (product) {
    case Product.TravelInsurance: return contractsTravelContext
    case Product.VehicleInsurance:
    case Product.FleetInsurance:
    case Product.VehicleLeasingInsurance: return contractsCarsContext
    case Product.LiabilityInsurance:
    case Product.PropertyInsurance: return contractsPropertyContext
    default: throw Error('Chybí property concepts context')
  }
}

export const TableWrapper = ({ children }: { children: React.ReactNode }) => {
  return <Box sx={{ maxW: '100%', overflow: 'hidden', overflowX: 'auto' }}>{children}</Box>
}

export const ContractsList = ({
  loading,
  contracts,
  withPaginator = false,
  leftFooterPart
}: {
  loading?: boolean
  contracts: InsuranceParamsGridItem[]
  withPaginator?: boolean
  leftFooterPart?: React.ReactNode
}) => {
  const { product } = useApp()
  const context = useMemo(() => getContractsContext(product!), [product])
  const { currentPage, pageSize, totalCount, setCurrentPage, reload, ...rest } = useContext(context)
  loading = loading || rest.loading

  return (
    <Box sx={{ display: 'grid', gap: 4 }}>
      <TableWrapper>
        <Table cellPadding="0" cellSpacing="0">
          <Thead>
            <TableRow hoverEffect={false}>
              <TableHeader>
                <p>Číslo smlouvy</p>
              </TableHeader>

              <TableHeader>
                <p>Číslo nabídky</p>
              </TableHeader>

              <TableHeader>
                <p>Datum sjednání</p>
                <p>Datum počátku</p>
              </TableHeader>

              <TableHeader sx={{ px: 0 }}>{/* <!-- Space for initials --> */}</TableHeader>

              <TableHeader sx={{ pl: 0 }}>
                {product == Product.VehicleLeasingInsurance && <p>Klient</p>}
                {product != Product.VehicleLeasingInsurance && <p>Pojistník</p>}
                {product == Product.VehicleInsurance && <p>Vozidlo</p>}
              </TableHeader>

              <TableHeader>
              </TableHeader>

              <TableHeader>
                <p>Název nabídky</p>
                <p>Zpracoval</p>
              </TableHeader>
            </TableRow>
          </Thead>

          <Tbody>
            {!loading && ((contracts?.length ?? 0) > 0) &&
              contracts.map((contract) => {
                return <ContractRow
                  key={`${contract.insuranceParamsId}_${contract.offerId}`}
                  item={contract} />
              })}

            {!loading && ((contracts?.length ?? 0) == 0) &&
              <TableRow>
                <TableData colSpan={7} py={8} textAlign={'center'}>
                  <Text>Žádné smlouvy k zobrazení</Text>
                </TableData>
              </TableRow>
            }

            {loading &&
              <TableRow>
                <TableData colSpan={7} py={8}>
                  <Loading large={true} />
                </TableData>
              </TableRow>
            }
          </Tbody>

          {withPaginator && !loading &&
            <Tfoot>
              <TableRow hoverEffect={false}>
                <TableData colSpan={7}>

                  <Grid gridTemplateColumns='1fr auto 1fr'>
                    {leftFooterPart && leftFooterPart}
                    {!leftFooterPart && <Box></Box>}

                    {withPaginator && (
                      <Pagination totalCount={totalCount} currentPage={currentPage} setCurrentPage={setCurrentPage} maxButtonCount={10} pageSize={pageSize} />
                    )}
                  </Grid>
                </TableData>
              </TableRow>
            </Tfoot>}

        </Table>
      </TableWrapper >


    </Box>
  )
}
